import React from 'react';
import { InputText } from '@insurancemenu/imenu-components-lib';
import { ElementsQuantityStyled, HeaderSectionStyled, QuantityStyled } from './styles';

export interface SearchSectionProps {
  /** Should be plural. */
  elementsTitle: string;
  page: number;
  currentElements: number;
  elementsPerPage: number;
  totalElements: number;
  searchInputPlaceholder: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchSection: React.FC<SearchSectionProps> = ({
  elementsTitle,
  page,
  currentElements,
  totalElements,
  elementsPerPage,
  searchInputPlaceholder,
  onSearch,
}) => {
  return (
    <HeaderSectionStyled>
      <ElementsQuantityStyled>
        <QuantityStyled>
          {currentElements > 0
            ? `${(page - 1) * elementsPerPage + 1} - ${Math.min(
                page * elementsPerPage,
                totalElements,
              )} / ${totalElements}`
            : '0'}
          {'  '}
        </QuantityStyled>
        {elementsTitle} on the page
      </ElementsQuantityStyled>
      <InputText htmlType="search" name="ee-search-input" placeholder={searchInputPlaceholder} onChange={onSearch} />
    </HeaderSectionStyled>
  );
};
